/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ContractDuration } from './contractDuration.model';
import { OutgoingPaymentState } from './outgoingPaymentState.model';
import { BarterState } from './barterState.model';
import { SubjectContactResponseDto } from './subjectContactResponseDto.model';
import { DepartmentOutgoingPayment } from './departmentOutgoingPayment.model';
import { ContactPaymentDataDto } from './contactPaymentDataDto.model';
import { PaymentType } from './paymentType.model';
import { MergedSubject } from './mergedSubject.model';
import { ContractResponseDto } from './contractResponseDto.model';
import { PaymentMethodCode } from './paymentMethodCode.model';
import { ContractPaymentDataDto } from './contractPaymentDataDto.model';


export interface OutgoingPaymentDto { 
    amount?: number;
    barterId?: number;
    barterNumber?: string;
    barterState?: BarterState;
    contract?: ContractResponseDto;
    contractDuration?: ContractDuration;
    contractId?: number;
    contractOfficialNumber?: string;
    contractPaymentData?: ContractPaymentDataDto;
    contractState?: string;
    departmentOutgoingPaymentList?: Array<DepartmentOutgoingPayment>;
    generatingDate?: string;
    id?: number;
    /**
     * True když platba je provedena bankovním převodem (PaymentMethodCode.B) a kód banky příjemce již není platný podle číselníku dtsrc_other.bank.
     */
    invalidBankAccount?: boolean;
    isRecipientPaymentSubjectRepresentative?: boolean;
    mergedContactPaymentData?: ContactPaymentDataDto;
    mergedRecipientSubject?: MergedSubject;
    note?: string;
    orderName?: string;
    paymentInfo?: Array<string>;
    paymentStatusCheck?: string;
    paymentType?: PaymentType;
    paymentYear?: number;
    payoutDate?: string;
    payoutDateOrder?: number;
    payoutDay?: number;
    payoutMonth?: number;
    recipientAccount?: string;
    recipientAddress?: string;
    recipientAddressCity?: string;
    recipientAddressCityPart?: string;
    recipientAddressHouseNumber?: string;
    recipientAddressPartOfVillage?: string;
    recipientAddressState?: string;
    recipientAddressStreet?: string;
    recipientAddressZipcode?: string;
    recipientFirstName?: string;
    recipientIban?: string;
    recipientIdentificationNumber?: string;
    recipientName?: string;
    recipientOriginalSubject?: SubjectContactResponseDto;
    recipientOriginalSubjectId?: number;
    recipientPaymentMethod?: PaymentMethodCode;
    recipientPaymentSubject?: SubjectContactResponseDto;
    recipientPaymentSubjectId?: number;
    recipientPersonalNumber?: string;
    recipientSubject?: SubjectContactResponseDto;
    recipientSubjectId?: number;
    recipientSurname?: string;
    recipientSwift?: string;
    recipientWithdrawPostage?: boolean;
    returnedDate?: string;
    sendDate?: string;
    senderSubjectId?: number;
    specificSymbol?: string;
    state?: OutgoingPaymentState;
    stateOrder?: number;
    variableSymbol?: string;
}
export namespace OutgoingPaymentDto {
}


